<template>
  <div id="ai-markdown-view" class="markdown-rendered markdown-view" :style="{ color: textColor }">
    <div ref="markdownView" class="markdown-view-content"></div>
  </div>
</template>

<script setup>
import { h, nextTick, onBeforeUnmount, onMounted, ref, render as vueRender, watch } from 'vue'
import MarkdownIt from 'markdown-it'
import './markdown-content.scss'
import ReferenceCard from '@/components/reference-card/index.vue'
import { evidencePlugin } from './evidence-plugin'

defineOptions({
  name: 'MarkdownView'
})

const props = defineProps({
  showString: {
    type: String,
    default: ''
  },
  textColor: {
    type: String,
    default: '#333'
  },
  htmlOptions: {
    type: Boolean,
    default: true
  }
})
const emit = defineEmits(['rendered'])

const markdownView = ref(null)
const mountedEvidenceEls = []

const md = new MarkdownIt({
  html: props.htmlOptions, // 允许 HTML 标签
  breaks: true // 将换行符转换为 <br> 标签
}).use(evidencePlugin)

const unmountEvidenceCards = () => {
  mountedEvidenceEls.splice(0).forEach((el) => {
    vueRender(null, el)
  })
}

const mountEvidenceCards = (evidences = []) => {
  if (!markdownView.value) return

  evidences.forEach(({ id, props: evidenceProps }) => {
    const el = markdownView.value.querySelector(`[data-evidence-id="${id}"]`)

    if (!el) return

    vueRender(h(ReferenceCard, evidenceProps), el)
    mountedEvidenceEls.push(el)
  })
}

const renderMarkdown = async () => {
  if (markdownView.value) {
    unmountEvidenceCards()

    const markdown = props.showString.replace(/&nbsp;/g, ' ').replace(/\\n/g, '\n')
    const env = { evidences: [] }

    markdownView.value.innerHTML = md.render(markdown, env)

    await nextTick()
    mountEvidenceCards(env.evidences)
    emit('rendered')
  }
}

onMounted(() => {
  renderMarkdown()
})

watch(
  () => props.showString,
  () => {
    renderMarkdown()
  }
)

onBeforeUnmount(() => {
  unmountEvidenceCards()
})
</script>
